export default __webpack_public_path__ + "static/media/estimate-step-3.332297fb.svg";